import { useEffect, useState } from 'react';
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading';
import FidelityPopupExcelDownload from './FidelityPopupExcelDownload';
import PopupDataGrid from '../../../component/common/popup/PopupDataGrid';

import '../../../css/data-grid.css';

const FidelityPopup = () => {
    const [data, setData] = useState([]);

    const head = ['병원명', '환자등록번호', '내원일자', '내원시간', '상태값']; //component화
    const head_column = ['EMOGDESC', 'PTMIIDNO', 'PTMIINDT', 'PTMIINTM', 'PTMISTAT'];

    const isSearched = true;

    const sendData = JSON.parse(localStorage.getItem('sendData'));

    const [loading, setLoading] = useState(true);

    let title_type = sendData.type;
    let title_name = sendData.clsdesc;

    const typeSuffixMap = {
        unknown: ' 미상',
        blank: ' 미입력',
        review: ' 재검토',
        error: ' 오류'
    };

    if (typeSuffixMap[title_type]) {
        title_name += typeSuffixMap[title_type];
    }

    const popupData = async () => {
        try {
            const response = await axios.get('/ptmiapi/fidelity_data_popup.do',
                { params: sendData }
            );
            setData(response.data.popupData);
            setLoading(false);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        setLoading(true);
        popupData();
    }, []);

    const flag = sendData.flag;

    return (
        <div className={`popup_container ${flag === 'ptmi' ? 'bg_st_bg' : flag === 'trms' ? 'bg_tr_bg' : ''}`}>
            <div className='flex justify-between'>
                <h4 className='sub_title w-70'>{title_name} 데이터 목록</h4>
                {loading || data.length === 0 ? '' :
                    <div className='btn_container mt-3'>
                        <FidelityPopupExcelDownload
                            data={data}
                            searched={isSearched}
                            menuName={'월별전송내역'}
                            ratioName={`${typeSuffixMap[title_type]}데이터목록`}
                            sendData={sendData}
                        />
                    </div>
                }
            </div>
            {loading ? <Loading /> :
                <PopupDataGrid
                    dataHead={head}
                    dataColumn={head_column}
                    dataList={data}
                    flag={flag} />
            }
        </div>
    )
}

export default FidelityPopup;